"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_uid_1 = require("react-uid");
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var color_1 = require("@seaweb/coral/utils/color");
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var Tip_1 = __importDefault(require("@seaweb/coral/components/Tip/Tip"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var useTooltip_1 = __importDefault(require("./useTooltip"));
var TooltipVariants;
(function (TooltipVariants) {
    TooltipVariants["Light"] = "light";
    TooltipVariants["Dark"] = "dark";
})(TooltipVariants = exports.TooltipVariants || (exports.TooltipVariants = {}));
var WrappedTip = forwardAs_1.default(Tip_1.default, ['variant']);
var StyledTip = styled_1.default(WrappedTip)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 280px;\n  line-height: 1.43;\n  pointer-events: none;\n  user-select: none;\n\n  ", "\n"], ["\n  max-width: 280px;\n  line-height: 1.43;\n  pointer-events: none;\n  user-select: none;\n\n  ",
    "\n"])), function (_a) {
    var variant = _a.variant, _b = _a.theme, factor = _b.spacing.factor, sizes = _b.typography.sizes, colors = _b.colors;
    switch (variant) {
        case TooltipVariants.Dark:
            return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          color: white;\n          background-color: ", ";\n          padding: ", "px ", "px;\n          font-size: ", "px;\n          box-shadow: 0 5px 20px ", ";\n          border: none;\n        "], ["\n          color: white;\n          background-color: ", ";\n          padding: ", "px ", "px;\n          font-size: ", "px;\n          box-shadow: 0 5px 20px ", ";\n          border: none;\n        "])), color_1.alp(colors.fadeAlternate, 0.9), factor * 2, factor * 4, sizes.small, color_1.alp(ThemeProvider_1.palette.black, 0.3));
        case TooltipVariants.Light:
        default:
            return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          padding: ", "px ", "px;\n        "], ["\n          padding: ", "px ", "px;\n        "])), factor * 2, factor * 3);
    }
});
var SPRING_CONFIG = { tension: 720, mass: 0.5 };
var OFFSET = [0, 2];
var Tooltip = react_1.forwardRef(function (_a, ref) {
    var title = _a.title, idProp = _a.id, _b = _a.role, role = _b === void 0 ? 'tooltip' : _b, _c = _a.container, container = _c === void 0 ? (getRoot_1.warnSSR('Tooltip', 'container'), getRoot_1.default()) : _c, _d = _a.variant, variant = _d === void 0 ? TooltipVariants.Dark : _d, children = _a.children, activeProp = _a.active, initialActive = _a.initialActive, onActiveChange = _a.onActiveChange, immediateProp = _a.immediate, initialImmediate = _a.initialImmediate, onImmediateChange = _a.onImmediateChange, _e = _a.springConfig, springConfig = _e === void 0 ? SPRING_CONFIG : _e, _f = _a.offset, offset = _f === void 0 ? OFFSET : _f, props = __rest(_a, ["title", "id", "role", "container", "variant", "children", "active", "initialActive", "onActiveChange", "immediate", "initialImmediate", "onImmediateChange", "springConfig", "offset"]);
    var child = react_1.Children.only(children);
    var _g = useTooltip_1.default(__assign(__assign({}, child.props), { active: activeProp, initialActive: initialActive,
        onActiveChange: onActiveChange, immediate: immediateProp, initialImmediate: initialImmediate,
        onImmediateChange: onImmediateChange })), active = _g.active, immediate = _g.immediate, handlers = _g.handlers;
    var colors = ThemeProvider_1.useThemeContext().colors;
    var arrowColor = (function () {
        switch (variant) {
            case TooltipVariants.Dark:
                return color_1.alp(colors.fadeAlternate, 0.9);
            case TooltipVariants.Light:
            default:
                return undefined;
        }
    })();
    var id = fallback_1.default(idProp, react_uid_1.useUID());
    var tooltipId = "tooltip:" + id;
    var ariaAttrs = {};
    if (active) {
        ariaAttrs['aria-describedby'] = [child.props['aria-describedby'], tooltipId].join(' ').trim();
    }
    return (react_1.default.createElement(StyledTip, __assign({ id: tooltipId, ref: ref, role: role, active: active, immediate: immediate, content: title, springConfig: springConfig, offset: offset, container: container, variant: variant, arrow: { color: arrowColor } }, props), react_1.cloneElement(child, __assign(__assign({}, handlers), ariaAttrs))));
});
exports.default = react_1.memo(Tooltip);
var templateObject_1, templateObject_2, templateObject_3;
